<mat-card class="recommendation-card" *ngIf="recommendation"
  [ngClass]="{'active': !recommendation.isComplete, 'high': recommendation.priority == 1, 'med': recommendation.priority == 2, 'low': recommendation.priority == 3 }">
  <mat-card-title class="title" (click)="openRecommendationDialog()">
    <h3 class="no-margin font-size-normal truncate"
      *ngIf="getBackupValue('title', recommendation, false)!=='' && getBackupValue('title', recommendation, false)!==null && getBackupValue('title', recommendation, false)!==undefined">
      {{getBackupValue('title', recommendation, false)}}</h3>
    <h3 class="no-margin font-size-normal truncate"
      *ngIf="getBackupValue('title', recommendation, false)==='' || getBackupValue('title', recommendation, false)===null || getBackupValue('title', recommendation, false)===undefined">
      {{'$common_no_translation' | translate}}</h3>
    <span class="example-spacer"></span>
    <span class="icons hiddenToolTip">
      <mat-icon>open_in_new</mat-icon>
      <span class="download-tool-tip" [innerHTML]="'$common_details' | translate"></span>
    </span>
  </mat-card-title>
  <mat-card-content>
    <div class="row section">
      <div *ngIf="recommendation.subject" class="col-xs-6">
        <div class="font-size-small"><span [innerHTML]="'$common_employee' | translate"></span>:</div>
        <div class="truncate">
          <cz-user-name-link [user]="recommendation?.subject"></cz-user-name-link>
        </div>
      </div>
      <div *ngIf="recommendation.recommendationDate" class="col-xs-6">
        <div class="font-size-small"><span [innerHTML]="'$common_recommended_on' | translate"></span>:</div>
        <div class="due-date">{{ recommendation?.recommendationDate | date:'MM-dd-yyyy' }}</div>
      </div>
    </div>
    <div class="row section">
      <div class="col-xs-6">
        <div class="font-size-small"><span [innerHTML]="'$common_created_by' | translate"></span>:</div>
        <div class="truncate" *ngIf="recommendation?.createdBy.id > 0">
          <cz-user-name-link [user]="recommendation?.createdBy"></cz-user-name-link>
        </div>
        <div class="truncate" *ngIf="recommendation?.createdBy.id < 1">
          {{ recommendation?.createdBy.displayName }}
          <div>&nbsp;</div>
        </div>

      </div>
      <div class="col-xs-6">
        <div class="font-size-small"><span [innerHTML]="'$common_priority' | translate"></span>:</div>
        <div class="priority-label">
          {{ recommendation?.priorityText }}
        </div>
      </div>
    </div>
    <div
      *ngIf="getBackupValue('text', recommendation, true)!=='' && getBackupValue('text', recommendation, true)!==null && getBackupValue('text', recommendation, true)!==undefined"
      class="row section">
      <div class="col-xs-12">
        <div class="font-size-small"><span [innerHTML]="'$common_details' | translate"></span>:</div>
        <div [innerHtml]="getBackupValue('text', recommendation, true)" class="truncate new_text"></div>
      </div>
    </div>
    <div *ngIf="getBackupValue('text', recommendation, true)===''" class="row section">
      <div class="col-xs-12">
        <div class="font-size-small"><span [innerHTML]="'$common_details' | translate"></span>:</div>
        <div class="truncate"> {{'$common_no_translation' | translate}}</div>
      </div>
    </div>
  </mat-card-content>
</mat-card>